// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BackButton_wrap__2aBLk","back":"BackButton_back__1dgtG"};